import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "./ResultPage3d.scss";
import { SocketState } from "../context/SocketProvider";

function ResultPopup3d() {
    const navigate = useNavigate();
    const { socket } = SocketState();

    // Local states
    const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
    const [resultData, setResultData] = useState(null); // ✅ store socket response here
    const container = useRef(null);

    // Emit request when date changes
    useEffect(() => {
        if (!socket) return;
        const payload = {
            en: "LUCKY_SORAT_RESULTS_HISTORY",
            data: { date: moment(fromDate, "YYYY-MM-DD").format("DD-MM-YYYY") },
        };
        // console.log("📤 Sending socket request:", payload);
        socket.emit("req", payload);
    }, [fromDate, socket]);

    // Listen for response
    useEffect(() => {
        if (!socket) return;

        const handleResponse = (response) => {
            if (response.en === "LUCKY_SORAT_RESULTS_HISTORY") {
                // console.log("📥 Received socket response:", response.data);
                setResultData(response.data || {});
            }
        };

        socket.on("res", handleResponse);
        return () => socket.off("res", handleResponse);
    }, [socket]);

    const animalImages = {
        "Ball": 'images/football111.gif',
        "Kite": 'images/kitework123.gif',
        "Cow": 'images/cat1212.gif',
        "Gariyo": 'images/horse1.gif',
        "Amrela": 'images/umbrela11.gif',
        "WatterDoll": 'images/bullet121.gif',
        "Butterfly": 'images/butterfly2121.gif',
        "Rose": 'images/rose132.gif',
        "Sun": 'images/tiger11.gif',
        "Lamp": 'images/dipak1231.gif',
        "Egle": 'images/kabutar123.gif',
        "Rebit": 'images/rabit132.gif'
    };

    return (
        <div className="myaccount_content">
            {/* Date Filter */}
            <div className="date_search_section flex items-center">
                <div className="w-full flex">
                    <div className="w-1/4 px-4">
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="from">
                                From
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                id="from"
                                type="date"
                                placeholder="from"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                max={moment().format("YYYY-MM-DD")}
                                min={"2023-04-01"}
                            />
                        </div>
                    </div>
                </div>
                <button
                    onClick={() => navigate('/result')}
                    className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                >
                    10/30/50
                </button>
                <button
                    onClick={() => navigate('/result1d')}
                    className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                >
                    2D
                </button>

                <button
                    onClick={() => navigate('/result3d')}
                    className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                >
                    3D
                </button>

                <button
                    onClick={() => navigate('/result2d')}
                    className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                >
                    4D
                </button>
                <button
                    onClick={() => navigate(-1)}
                    className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                >
                    Back
                </button>
            </div>

            {/* Table Section */}
            <div className="history_table_div overflow-y-auto pb-16" ref={container}>
                <table className="table table-borderless history_table">
                    <thead className="sticky top-0">
                        <tr>
                            <th className="text-center">TIME</th>
                            {/* Dynamically render columns based on response */}
                            {resultData?.dates?.length > 0 &&
                                resultData.dates.map((date, index) => (
                                    <th key={index} className="text-center">
                                        {date}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {resultData && Object.keys(resultData.time_result || {}).length > 0 ? (
                            Object.keys(resultData.time_result)
                                .filter((time) => {
                                    // convert to moment using 12-hour format
                                    const t = moment(time, "hh:mm:ss A");
                                    const start = moment("09:00:00 AM", "hh:mm:ss A");
                                    const end = moment("10:00:00 PM", "hh:mm:ss A");
                                    return t.isBetween(start, end, null, "[]"); // include boundary
                                })
                                .map((timeKey, timeIndex) => (
                                    <tr key={timeIndex}>
                                        <td className="text-center">{timeKey}</td>
                                        {resultData.time_result[timeKey].map((value, valueIndex) => (
                                            <td key={valueIndex}>
                                                <div className="result_his_line">
                                                    {value &&
                                                        (value.includes("&")
                                                            ? value.split("&").map((pair, idx) => {
                                                                const parts = pair.split("=");
                                                                return (
                                                                    <div
                                                                        key={idx}
                                                                        className={`result_span_10_series text-center three_game_result_his${idx + 1}`}
                                                                    >
                                                                        {parts[0]} - {parts[1] || ""}
                                                                    </div>
                                                                );
                                                            })
                                                            : (() => {
                                                                const parts = value.split("=");
                                                                return (
                                                                    <div className="result_span_10_series text-center">
                                                                        <center>
                                                                            <img
                                                                                src={`${animalImages[parts[1] || value]}`}
                                                                                style={{
                                                                                    width: '90px',
                                                                                    height: '90px',
                                                                                    marginBottom: '-2px',
                                                                                }}
                                                                                alt={parts[1] || value}
                                                                            />
                                                                        </center>
                                                                    </div>
                                                                );
                                                            })())}
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                        ) : (
                            <tr>
                                <td colSpan={8} className="text-center py-4 text-gray-500">
                                    No result found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ResultPopup3d;
